import React from 'react';
import HeaderRow from '../HeaderRow';
import CheckboxCell from '../CheckboxCell';
import Cell from '../Cell';
import { useStateControllers, useStateSelector } from '../../stateManager';
import { selectAllCheckboxState } from '../../utils/selectors';
import { stateKeys } from '../../constants';
import { useRowSelectionHandlers } from '../../services/rowSelection';

const Header = ({ columns, withCheckbox }) => {
  const colOffset = withCheckbox ? 2 : 1;

  return (
    <HeaderRow>
      {withCheckbox && <CheckboxBlock />}

      {columns.map((col, index) => {
        const { key, label, filter } = col;

        const props = {
          column: colOffset + index,
          placement: 'header',
          ...(index === 0 ? { type: 'first' } : {}),
        };

        return (
          <Cell key={key} {...props}>
            {label}
            {filter}
          </Cell>
        );
      })}
    </HeaderRow>
  );
};

export default Header;

function CheckboxBlock() {
  const selectedState = useStateSelector(selectAllCheckboxState);

  const { onSelectAll } = useRowSelectionHandlers();

  const { getValue } = useStateControllers();

  const selected = selectedState === 'checked';

  const handleClick = () => {
    onSelectAll({
      keys: getValue(stateKeys.preparedDataIdsSet),
      selected: !selected,
    });
  };

  return (
    <CheckboxCell
      placement="header"
      checked={selected}
      indeterminate={selectedState === 'indeterminate'}
      onClick={handleClick}
    />
  );
}
